var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulkEnquiries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30.476,
    viewBox: "0 0 32 30.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7915",
    d: "M37.476 39.238h-12.19A2.286 2.286 0 0 1 23 36.952V26.286A2.286 2.286 0 0 1 25.286 24h12.19a2.286 2.286 0 0 1 2.286 2.286v10.666a2.286 2.286 0 0 1-2.286 2.286zm-12.19-13.714a.762.762 0 0 0-.762.762v10.666a.762.762 0 0 0 .762.762h12.19a.762.762 0 0 0 .762-.762V26.286a.762.762 0 0 0-.762-.762z",
    transform: "translate(-7.762 -8.762)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7916",
    d: "M29.048 20.762H12.286A2.286 2.286 0 0 1 10 18.476V6.286A2.286 2.286 0 0 1 12.286 4h16.762a2.286 2.286 0 0 1 2.286 2.286v12.19a2.286 2.286 0 0 1-2.286 2.286zM12.286 5.524a.762.762 0 0 0-.762.762v12.19a.762.762 0 0 0 .762.762h16.762a.762.762 0 0 0 .762-.762V6.286a.762.762 0 0 0-.762-.762z",
    transform: "translate(-4.667 -4)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7917",
    d: "M17.476 39.238H5.286A2.286 2.286 0 0 1 3 36.952V26.286A2.286 2.286 0 0 1 5.286 24h12.19a2.286 2.286 0 0 1 2.286 2.286v10.666a2.286 2.286 0 0 1-2.286 2.286zM5.286 25.524a.762.762 0 0 0-.762.762v10.666a.762.762 0 0 0 .762.762h12.19a.762.762 0 0 0 .762-.762V26.286a.762.762 0 0 0-.762-.762z",
    transform: "translate(-3 -8.762)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7918",
    d: "M15.1 31.912a1.529 1.529 0 0 1-.686-.162l-1.6-.8-1.6.8A1.524 1.524 0 0 1 9 30.386v-5.624A.762.762 0 0 1 9.762 24h6.1a.762.762 0 0 1 .762.762v5.624A1.528 1.528 0 0 1 15.1 31.91zm-2.29-2.487a1.524 1.524 0 0 1 .681.159l1.6.8v-4.86h-4.567v4.862l1.6-.8a1.528 1.528 0 0 1 .682-.159z",
    transform: "translate(-4.429 -8.762)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7919",
    d: "M35.1 31.912a1.529 1.529 0 0 1-.686-.162l-1.6-.8-1.6.8A1.524 1.524 0 0 1 29 30.386v-5.624a.762.762 0 0 1 .762-.762h6.1a.762.762 0 0 1 .762.762v5.624A1.528 1.528 0 0 1 35.1 31.91zm-2.29-2.487a1.524 1.524 0 0 1 .681.159l1.6.8v-4.86h-4.567v4.862l1.6-.8a1.528 1.528 0 0 1 .686-.161z",
    transform: "translate(-9.19 -8.762)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7920",
    d: "M20.286 14.075A2.286 2.286 0 0 1 18 11.79V4.762A.762.762 0 0 1 18.762 4h7.619a.762.762 0 0 1 .762.762v6.892a2.286 2.286 0 0 1-3.134 2.123l-1.1-.44a.762.762 0 0 0-.61.021l-1.022.491a2.29 2.29 0 0 1-.992.227zm-.762-8.552v6.264a.762.762 0 0 0 1.092.686l1.022-.491a2.3 2.3 0 0 1 1.838-.062l1.1.44a.762.762 0 0 0 1.045-.707V5.524z",
    transform: "translate(-6.571 -4)",
    style: {
      fill: "currentColor"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkEnquiries);
export default __webpack_public_path__ + "static/media/bulk_enquiries.2598e3dfdb9b849ba022bff3c2a6092e.svg";
export { ForwardRef as ReactComponent };